import React from 'react';
//icons
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaidIcon from '@mui/icons-material/Paid';
import PercentIcon from '@mui/icons-material/Percent';
import ShutterSpeedIcon from '@mui/icons-material/ShutterSpeed';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import CommentIcon from '@mui/icons-material/Comment';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CancelIcon from '@mui/icons-material/Cancel';
import EmailIcon from '@mui/icons-material/Email';
import PauseIcon from '@mui/icons-material/Pause';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
const IconAnalitics = ({ icon }) => {
  let componentToRender;
  switch (icon) {
    case 'LocalPhoneIcon':
      componentToRender = <LocalPhoneIcon />;
      break;
    case 'AccessTimeIcon':
      componentToRender = <AccessTimeIcon />;
      break;
    case 'PhoneInTalkIcon':
      componentToRender = <PhoneInTalkIcon />;
      break;
    case 'PercentIcon':
      componentToRender = <PercentIcon />;
      break;
    case 'ShutterSpeedIcon':
      componentToRender = <ShutterSpeedIcon />;
      break;
    case 'PaidIcon':
      componentToRender = <PaidIcon />;
      break;
    case 'CheckCircleIcon':
      componentToRender = <CheckCircleIcon />;
      break;
    case 'PlaylistAddCheckCircleIcon':
      componentToRender = <PlaylistAddCheckCircleIcon />;
      break;
    case 'ErrorIcon':
      componentToRender = <ErrorIcon />;
      break;
    case 'CommentIcon':
      componentToRender = <CommentIcon />;
      break;
    case 'CommentsDisabledIcon':
      componentToRender = <CommentsDisabledIcon />;
      break;
    case 'HourglassBottomIcon':
      componentToRender = <HourglassBottomIcon />;
      break;
    case 'CancelIcon':
      componentToRender = <CancelIcon />;
      break;
    case 'EmailIcon':
      componentToRender = <EmailIcon />;
      break;
    case 'PauseIcon':
      componentToRender = <PauseIcon />;
      break;
    case 'RotateLeftIcon':
      componentToRender = <RotateLeftIcon />;
      break;
    case 'ArrowDownward':
      componentToRender = <ArrowDownward sx={{ width: '1rem' }} />;
      break;
    case 'ArrowUpward':
      componentToRender = <ArrowUpward sx={{ width: '1rem' }} />;
      break;
    default:
      break;
  }
  return <>{componentToRender}</>;
};

export default IconAnalitics;
